export default function isArr(v) {
  return Array.isArray(v)
}
